import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { CimaCore, Cloudinary, Util, WindowReference, XmStore, XmStoreUtil } from 'core/services';
import { CmsCore } from 'store/cms/models';

@Component({
    selector: 'xm-nav-logo',
    styleUrls: ['./logo.scss'],
    templateUrl: './logo.html',
    standalone: false
})
export class NavLogoComponent implements OnInit, OnDestroy {
    @Output() public closeHamburgerNavFromLogo: EventEmitter<void> = new EventEmitter<void>();
    public imageOptions: MediaImageOptions;
    public url: string;
    public isBusinessUser: boolean;

    private cimaCore: CimaCore;
    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;

    constructor(cimaCore: CimaCore, xmStore: XmStore, windowRef: WindowReference) {
        Object.assign(this, { cimaCore, xmStore, windowRef });
    }

    public ngOnInit(): void {
        this.isBusinessUser = this.cimaCore.isBusinessUser;

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsCore>(CmsCore), (result: CmsCore) => {
            if (!this.isBusinessUser) {
                this.imageOptions = {
                    mobile: {
                        base: result.nav.newXMLogo
                    }
                };
            } else {
                this.imageOptions = {
                    mobile: Cloudinary.generateMediaFromCms(result.nav.cbmLogo)
                };
            }
            
            this.url = this.isBusinessUser ? result.nav.cbmLogoUrl : result.nav.logoUrl;
        }));
    }

    public closeNav(): void {
        this.closeHamburgerNavFromLogo.emit();
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
